import AdminRoute from "@/components/AdminRoute";
import RoleGuard from "@/components/RoleGuard";
import Gallery from "@/pages/public/gallery/GalleryPage";
import Documents from "@/pages/public/documents/DocumentPage";
import EventInfo from "@/pages/public/event-info/EventInfoPage";
import NotFound from "@/pages/NotFound";
import CountDown from "@/pages/public/countdown";
import LoginPage from "@/pages/auth/LoginPage";
import LandingPage from "@/pages/public/LandingPage";
import DashboardPage from "@/pages/private/dashboard/DashboardPage";
import PrivateRoute from "@/components/PrivateRoute";
import RegistrationPage from "@/pages/public/daftar/RegistrationPage";
import { createBrowserRouter } from "react-router-dom";
import UniversitiesList from "@/components/UniversitiesList";
import ScrollToTop from "@/components/ScrollToTop";
import RegisterSuccessPage from "@/pages/public/daftar/RegistrationSuccessPage";
import AccountActivationProcess from "@/pages/public/daftar/AccountActivationProcess";
import AccountActivatedPage from "@/pages/public/daftar/AccountActivatedPage";
import ActivationFailedPage from "@/pages/public/daftar/ActivationFailedPage";
import ActivationAlreadyPage from "@/pages/public/daftar/ActivationAlreadyPage";
import ForgotPasswordPage from "@/pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/auth/ResetPasswordPage";
// import KonfirmasiPage from "@/pages/private/lama/KonfirmasiPage";
// import CheckoutPage from "@/pages/private/lama/CheckoutPage";
// import KartuPesertaPage from "@/pages/private/lama/KartuPesertaPage";
import StepPaket from "@/components/private/paket/StepPaket";
import StepKonfirmasi from "@/pages/private/order/StepKonfirmasi";
import StepPembayaran from "@/pages/private/order/StepPembayaran";
import StepKartu from "@/pages/private/order/StepKartu";
import Layout from "@/components/private/layout/Layout";
import ProfilePage from "@/pages/private/profile/ProfilePage";
import AboutPage from "@/pages/private/about/AboutPage";
import ConferenceTracks from "@/components/public/ConferenceTracks";
import LogoutPage from "@/pages/auth/LogoutPage";
import StepStatusPembayaran from "@/pages/private/order/StepStatusPembayaran";
import StepGuard from "@/components/private/StepGuard";
import PocketBookPage from "@/pages/public/pocket-book/PocketBookPage";
import GuestRoute from "@/components/GuestRoute";
import Reports from "@/components/private/admin/reports/Reports";
import MaintenancePage from "@/pages/public/MaintenancePage";
import SiteGuard from "@/components/SiteGuard";
import SettingAppPage from "@/pages/private/settings/SettingAppPage";

import GATracker from "@/components/GATracker";
import StepImported from "@/pages/private/order/StepImported";
import ConferencePaymentPage from "@/pages/public/conference-payment/ConferencePaymentPage";
import ConferenceInvoicePage from "@/pages/public/conference-payment/ConferenceInvoicePage";
import ConferenceOutputDecisionPage from "@/pages/public/conference-output/ConferenceOutputDecisionPage";
import ConferenceOutputRegistrationPage from "@/pages/public/conference-output/ConferenceOutputRegistrationPage";
import ConferenceOutputBillingPage from "@/pages/public/conference-output/ConferenceOutputBillingPage";
import MainroomAttendancePage from "@/pages/public/mainroom-attendance/MainroomAttendancePage";
import FeedbackPage from "@/pages/public/feedback/FeedbackPage";
import ConferenceVerificationPage from "@/pages/private/conference-verification/ConferenceVerificationPage";
import ConferenceCheckPage from "@/pages/private/conference-check/ConferenceCheckPage";
// import ConferenceVerificationPendingPage from "@/pages/public/conference-payment/ConferenceVerificationPendingPage";

import CollectiveBillingPage from "@/pages/private/collective-billing/CollectiveBillingPage";
import CollectiveDetailPage from "@/pages/private/collective-billing/CollectiveDetailPage";
import BrinIseasJoinConferencePage from "@/pages/public/brin-iseas/BrinIseasJoinConferencePage";
import RfidRegisterPage from "@/pages/private/admin/rfid/RfidRegisterPage";
import RfidScanPage from "@/pages/private/admin/rfid/RfidScanPage";

import PeriodsPage from "@/pages/private/admin/periods/PeriodsPage";
import PackagesPage from "@/pages/private/admin/packages/PackagesPage";
import DocumentsPage from "@/pages/private/admin/documents/DocumentsPage";
import GalleryAdminPage from "@/pages/private/admin/gallery/GalleryPage";
import RolesPage from "@/pages/private/admin/roles/RolesPage";
import UsersPage from "@/pages/private/admin/users/UsersPage";
import ParticipantsPage from "@/pages/private/admin/participants/ParticipantsPage";
import EventGuestsPage from "@/pages/private/admin/event-guests/EventGuestsPage";
import CertificatesPage from "@/pages/private/admin/certificates/CertificatesPage";
import CertificateTemplatesPage from "@/pages/private/admin/certificates/CertificateTemplatesPage";
import TteOfficialsPage from "@/pages/private/admin/certificates/TteOfficialsPage";
import CertificateTypesPage from "@/pages/private/admin/certificates/CertificateTypesPage";
import ConferencesPage from "@/pages/private/admin/conference/ConferencesPage";
import RoomsPage from "@/pages/private/admin/conference/RoomsPage";
import RoomParticipantsPage from "@/pages/private/admin/conference/RoomParticipantsPage";
import SpeakersPage from "@/pages/private/admin/conference/SpeakersPage";
import AdminMainroomAttendancePage from "@/pages/private/admin/mainroom/MainroomAttendancePage";
import AdminFeedbackPage from "@/pages/private/admin/feedback/FeedbackPage";
import AttendancePage from "@/pages/private/conference-attendance/AttendancePage";
import ErrorBoundary from "@/components/ErrorBoundary";
import { ConventionReportPage } from "@/pages/private/admin/convention-report/ConventionReportPage";
import OutputDecisionsPage from "@/pages/private/admin/conference-output/OutputDecisionsPage";
import OutputMasterJournalsPage from "@/pages/private/admin/conference-output/OutputMasterJournalsPage";
import OutputFeesPage from "@/pages/private/admin/conference-output/OutputFeesPage";
import OutputBillingsPage from "@/pages/private/admin/conference-output/OutputBillingsPage";
import OutputSettingsPage from "@/pages/private/admin/conference-output/OutputSettingsPage";
import OutputPublishersPage from "@/pages/private/admin/conference-output/OutputPublishersPage";

export const router = createBrowserRouter([
  {
    element: <GATracker />,
    errorElement: <ErrorBoundary />,
    children: [
      { path: "/maintenance", element: <MaintenancePage /> },
      { path: "/countdown", element: <CountDown /> },
      {
        path: "/login", element: (
          <GuestRoute>
            <LoginPage />
          </GuestRoute>
        )
      },
      { path: "/logout", element: <LogoutPage /> },
      { path: "/univ-list", element: <UniversitiesList /> },
      { path: "/registration/success", element: <RegisterSuccessPage /> },

      { path: "/activate/:token", element: <AccountActivationProcess /> },

      { path: "/activation/success", element: <AccountActivatedPage /> },
      { path: "/activation/failed", element: <ActivationFailedPage /> },
      { path: "/activation/already", element: <ActivationAlreadyPage /> },

      { path: "/forgot-password", element: <ForgotPasswordPage /> },
      { path: "/reset-password", element: <ResetPasswordPage /> },

      {
        path: "/",
        element: (
          // <PrivateRoute>
          <SiteGuard>
            <LandingPage />
          </SiteGuard>
          // </PrivateRoute>
        ),
      },
      {
        // Satu Layout bersama untuk SEMUA halaman private (dashboard, /admin/*, /settings/*).
        // PENTING: jangan dipecah lagi jadi beberapa route terpisah yang masing-masing
        // membungkus <Layout/> sendiri - React Router akan meng-unmount+mount ulang Layout
        // (dan Sidebar di dalamnya) setiap kali pindah antar route-tree yang berbeda, walau
        // path-nya sama-sama "/admin". Efeknya: sidebar terlihat "reload" dan scroll position-nya
        // selalu balik ke atas. Guard role sekarang dipasang per-halaman (bukan per-cabang),
        // supaya navigasi antar menu hanya mengganti <Outlet/> tanpa remount Layout/Sidebar.
        path: "",
        element: (
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        ),
        children: [
          { path: "dashboard", element: <DashboardPage /> },
          { path: "profile", element: <ProfilePage /> },
          { path: "about", element: <AboutPage /> },
          { path: "conference-tracks", element: <ConferenceTracks /> },
          { path: "conference-check", element: <ConferenceCheckPage /> },
          { path: "conference-verification", element: <ConferenceVerificationPage /> },
          { path: "conference-attendance", element: <AttendancePage /> },
          { path: "collective-billing", element: <CollectiveBillingPage /> },
          { path: "collective-billing/:id", element: <CollectiveDetailPage /> },

          { path: "settings/app", element: <AdminRoute><SettingAppPage /></AdminRoute> },

          // Khusus Administrator (1)
          { path: "admin/periods", element: <AdminRoute><PeriodsPage /></AdminRoute> },
          { path: "admin/packages", element: <AdminRoute><PackagesPage /></AdminRoute> },
          { path: "admin/documents", element: <AdminRoute><DocumentsPage /></AdminRoute> },
          { path: "admin/gallery", element: <AdminRoute><GalleryAdminPage /></AdminRoute> },
          { path: "admin/roles", element: <AdminRoute><RolesPage /></AdminRoute> },
          { path: "admin/users", element: <AdminRoute><UsersPage /></AdminRoute> },
          { path: "admin/participants", element: <AdminRoute><ParticipantsPage /></AdminRoute> },
          { path: "admin/certificates", element: <AdminRoute><CertificatesPage /></AdminRoute> },
          { path: "admin/certificate-types", element: <AdminRoute><CertificateTypesPage /></AdminRoute> },
          { path: "admin/certificate-templates", element: <AdminRoute><CertificateTemplatesPage /></AdminRoute> },
          { path: "admin/certificates/officials", element: <AdminRoute><TteOfficialsPage /></AdminRoute> },
          { path: "admin/reports", element: <AdminRoute><Reports /></AdminRoute> },

          // Khusus Administrator (1) & Operator Conference (4)
          { path: "admin/conferences", element: <RoleGuard allowedRoles={[1]}><ConferencesPage /></RoleGuard> },
          { path: "admin/conference-rooms", element: <RoleGuard allowedRoles={[1, 4]}><RoomsPage /></RoleGuard> },
          { path: "admin/conference-speakers", element: <RoleGuard allowedRoles={[1, 4]}><SpeakersPage /></RoleGuard> },
          { path: "admin/conference-rooms/:roomId/participants", element: <RoleGuard allowedRoles={[1, 4]}><RoomParticipantsPage /></RoleGuard> },
          { path: "admin/mainroom-attendance", element: <RoleGuard allowedRoles={[1, 4]}><AdminMainroomAttendancePage /></RoleGuard> },
          { path: "admin/feedback", element: <RoleGuard allowedRoles={[1, 4]}><AdminFeedbackPage /></RoleGuard> },

          // Khusus Dashboard Pimpinan: Administrator (1) & Pimpinan (8)
          { path: "admin/convention-report", element: <RoleGuard allowedRoles={[1, 8]}><ConventionReportPage /></RoleGuard> },

          // Khusus RFID: Administrator (1) & Petugas RFID (7)
          { path: "admin/rfid/register", element: <RoleGuard allowedRoles={[1, 7]}><RfidRegisterPage /></RoleGuard> },
          { path: "admin/rfid/scan", element: <RoleGuard allowedRoles={[1, 7]}><RfidScanPage /></RoleGuard> },
          { path: "admin/event-guests", element: <RoleGuard allowedRoles={[1, 7]}><EventGuestsPage /></RoleGuard> },

          // Khusus Output Conference: Administrator (1) & Operator Output Conference (10) & Operator Conference (4)
          { path: "admin/output-conference/decisions", element: <RoleGuard allowedRoles={[1, 4, 10]}><OutputDecisionsPage /></RoleGuard> },
          { path: "admin/output-conference/master-journals", element: <RoleGuard allowedRoles={[1, 4, 10]}><OutputMasterJournalsPage /></RoleGuard> },
          { path: "admin/output-conference/fees", element: <RoleGuard allowedRoles={[1, 4, 10]}><OutputFeesPage /></RoleGuard> },
          { path: "admin/output-conference/billings", element: <RoleGuard allowedRoles={[1, 4, 10]}><OutputBillingsPage /></RoleGuard> },
          { path: "admin/output-conference/publishers", element: <RoleGuard allowedRoles={[1, 4, 10]}><OutputPublishersPage /></RoleGuard> },
          { path: "admin/output-conference/settings", element: <RoleGuard allowedRoles={[1, 4, 10]}><OutputSettingsPage /></RoleGuard> },
        ],
      },
      {
        path: "/order",
        element: (
          <PrivateRoute>
            <StepGuard>
              <Layout />
            </StepGuard>
          </PrivateRoute>
        ),
        children: [
          { index: true, element: <StepPaket /> },
          { path: "paket", element: <StepPaket /> },
          { path: "konfirmasi", element: <StepKonfirmasi /> },
          { path: "pembayaran", element: <StepPembayaran /> },
          { path: "pembayaran/status", element: <StepStatusPembayaran /> },
          { path: "kartu", element: <StepKartu /> },
          { path: "imported", element: <StepImported /> },
        ],
      },
      // {
      //   path: "/konfirmasi",
      //   element: (
      //     <PrivateRoute>
      //       <KonfirmasiPage />
      //     </PrivateRoute>
      //   ),
      // },
      // {
      //   path: "/checkout",
      //   element: (
      //     <PrivateRoute>
      //       <CheckoutPage />
      //     </PrivateRoute>
      //   ),
      // },
      // {
      //   path: "/kartu",
      //   element: (
      //     <PrivateRoute>
      //       <KartuPesertaPage />
      //     </PrivateRoute>
      //   ),
      // },
      {
        path: "/conference-payment",
        element: (
          // <PrivateRoute>
          <SiteGuard>
            <ScrollToTop />
            <ConferencePaymentPage />
          </SiteGuard>
          // </PrivateRoute>
        ),
      },
      {
        path: "/conference-payment/invoice/:token",
        element: (
          <SiteGuard>
            <ScrollToTop />
            <ConferenceInvoicePage />
          </SiteGuard>
        ),
      },
      {
        path: "/conference-output/decision/:token",
        element: (
          <SiteGuard>
            <ScrollToTop />
            <ConferenceOutputDecisionPage />
          </SiteGuard>
        ),
      },
      {
        path: "/conference-output/registration/:token",
        element: (
          <SiteGuard>
            <ScrollToTop />
            <ConferenceOutputRegistrationPage />
          </SiteGuard>
        ),
      },
      {
        path: "/conference-output/billing/:token",
        element: (
          <SiteGuard>
            <ScrollToTop />
            <ConferenceOutputBillingPage />
          </SiteGuard>
        ),
      },
      {
        path: "/mainroom-attendance",
        element: (
          <SiteGuard>
            <ScrollToTop />
            <MainroomAttendancePage />
          </SiteGuard>
        ),
      },
      {
        path: "/feedback",
        element: (
          <SiteGuard>
            <ScrollToTop />
            <FeedbackPage />
          </SiteGuard>
        ),
      },
      // {
      //   path: "/conference-payment/verification-pending/:token",
      //   element: (
      //     <SiteGuard>
      //       <ScrollToTop />
      //       <ConferenceVerificationPendingPage />
      //     </SiteGuard>
      //   ),
      // },
      {
        path: "/registration/convention",
        element: (
          // <PrivateRoute>
          <SiteGuard>
            <ScrollToTop />
            <RegistrationPage />
          </SiteGuard>
          // </PrivateRoute>
        ),
      },
      {
        path: "/gallery",
        element: (
          // <PrivateRoute>
          <SiteGuard>
            <ScrollToTop />
            <Gallery />
          </SiteGuard>
          // </PrivateRoute>
        ),
      },
      {
        path: "/documents",
        element: (
          // <PrivateRoute>
          <SiteGuard>
            <ScrollToTop />
            <Documents />
          </SiteGuard>
          // </PrivateRoute>
        ),
      },
      {
        path: "/event-info",
        element: (
          // <PrivateRoute>
          <SiteGuard>
            <ScrollToTop />
            <EventInfo />
          </SiteGuard>
          // </PrivateRoute>
        ),
      },
      {
        path: "/pocket-book",
        element: (
          // <PrivateRoute>
          <SiteGuard>
            <ScrollToTop />
            <PocketBookPage />
          </SiteGuard>
          // </PrivateRoute>
        ),
      },
      {
        path: "/conference/kemendiktisaintek-brin-iseas-konaspi-xii-undiksha",
        element: (
          // <PrivateRoute>
          <SiteGuard>
            <ScrollToTop />
            <BrinIseasJoinConferencePage />
          </SiteGuard>
          // </PrivateRoute>
        ),
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ]
  },
]);
